import { observer } from 'mobx-react';
import React from 'react';

import { Typography } from '@mui/material';
import { DateTime } from 'luxon';
import GradeBookLessons from 'modules/GradeBook/components/Lessons';
import { capitalizeFirstLetter } from '@common/helpers/capitalizeFirstLetter';

import { IClientGradeBookModel } from '@common/models/ClientGradeBook/ClientGradeBook';

import { StyledGradeBookWeekDaySection, StyledGradeBookWeekDayWrap } from './styled';

interface PropsType {
	gradeBooks: IClientGradeBookModel[];
	day: DateTime<boolean>;
	onSelectLesson?: (lesson: IClientGradeBookModel) => void;
}

function WeekDayView({ gradeBooks, day, onSelectLesson }: PropsType) {
	const dayOfWeek = capitalizeFirstLetter(day.toFormat('EEE'));
	const monthAndDate = day.toFormat('MMM dd');

	return (
		<StyledGradeBookWeekDayWrap>
			<StyledGradeBookWeekDaySection elevation={2}>
				<Typography variant="subtitle1">{dayOfWeek}</Typography>
				<Typography variant="body2" color="text.helper">
					{monthAndDate}
				</Typography>
			</StyledGradeBookWeekDaySection>
			<GradeBookLessons gradeBooks={gradeBooks} onSelectLesson={onSelectLesson} mode="week" />
		</StyledGradeBookWeekDayWrap>
	);
}

export default observer(WeekDayView);
